import React from 'react';
import { connect } from 'react-redux';
import ContentLoader from 'react-content-loader';
import { fakeSettings } from '@/constants/constants';
import styles from './styles';

const DataManagementFake = () => {
  return (
    <div className="InternetDetailFake">
      <div className="row">
        <div className="col-xs-12 col-sm-12" >
          <ContentLoader
            height="720"
            width="700"
            {...fakeSettings}
          > <rect x="100" y="25" width="500" height="180" rx="1" ry="1" />
            <rect x="180" y="325" width="350" height="225" rx="1" ry="1" />
          </ContentLoader>
        </div>
      </div>
      <style jsx>{styles}</style>
    </div>
  );
}

export default DataManagementFake;
